export default "__VITE_ASSET__gNL$OHAJ__"